module.exports = __webpack_public_path__ + "static/media/calendar.df03f04c.svg";